const MainContainer = ({children}: {children: any}) => {
    return (
        <div className="flex flex-col w-full max-w-3xl pb-6 mx-auto justify-start items-center relative">
            {children}
        </div>
    );
};

export default MainContainer;